/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TaskInfo,
    TaskInfoFromJSON,
    TaskInfoFromJSONTyped,
    TaskInfoToJSON,
} from './';

/**
 * 
 * @export
 * @interface DownloadArchivePartialUpdate
 */
export interface DownloadArchivePartialUpdate {
    /**
     * 
     * @type {TaskInfo}
     * @memberof DownloadArchivePartialUpdate
     */
    taskInfo?: TaskInfo;
    /**
     * 
     * @type {string}
     * @memberof DownloadArchivePartialUpdate
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DownloadArchivePartialUpdate
     */
    path?: string;
    /**
     * 
     * @type {number}
     * @memberof DownloadArchivePartialUpdate
     */
    progressUnit?: DownloadArchivePartialUpdateProgressUnitEnum;
    /**
     * 
     * @type {number}
     * @memberof DownloadArchivePartialUpdate
     */
    user?: number | null;
}

/**
* @export
* @enum {string}
*/
export enum DownloadArchivePartialUpdateProgressUnitEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1
}

export function DownloadArchivePartialUpdateFromJSON(json: any): DownloadArchivePartialUpdate {
    return DownloadArchivePartialUpdateFromJSONTyped(json, false);
}

export function DownloadArchivePartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): DownloadArchivePartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'taskInfo': !exists(json, 'task_info') ? undefined : TaskInfoFromJSON(json['task_info']),
        'name': !exists(json, 'name') ? undefined : json['name'],
        'path': !exists(json, 'path') ? undefined : json['path'],
        'progressUnit': !exists(json, 'progress_unit') ? undefined : json['progress_unit'],
        'user': !exists(json, 'user') ? undefined : json['user'],
    };
}

export function DownloadArchivePartialUpdateToJSON(value?: DownloadArchivePartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'task_info': TaskInfoToJSON(value.taskInfo),
        'name': value.name,
        'path': value.path,
        'progress_unit': value.progressUnit,
        'user': value.user,
    };
}


